<template>
  <span
    styleName="triangle"
    :style="{
      transform: `rotate(${rotate}deg)`,
      'border-left-width': `${borderSideWidth}px`,
      'border-right-width': `${borderSideWidth}px`,
      'border-bottom-width': `${borderBottomWidth}px`,
      'border-bottom-color': bg
      }"
    >
  </span>
</template>

<script>
import styles from './index.scss'
import CSSModules from 'vue-css-modules'

export default {
  name: 'Triangle',
  mixins: [CSSModules(styles)],
  props: {
    rotate: {
      type: Number | String,
      default: 180
    },
    borderSideWidth: {
      type: Number | String,
      default: 7
    },
    borderBottomWidth: {
      type: Number | String,
      default: 7
    },
    bg: {
      require: false,
      default: '#BEBEBE'
    }
  },
  data: () => {
    return {
    }
  }
}
</script>
